import root from './root';

import screenSize from './screenSize';

export default [root, screenSize];
